import React from 'react';

import FbComments from '@vg/fb-comments';

import { config } from '../../config';

// eslint-disable-next-line react/prop-types
const Comments = ({ url, value, ...rest }) => {
    if (!value) {
        return null;
    }

    const {
        comments: {
            facebook: {
                appId,
                buttonText,
                commentsAlwaysOpen,
                commentsClosedHeading,
                commentsClosedText,
                commentsCloseHour,
                commentsOpenHour,
                cookie,
                lang,
                minutesLeftWhenWarningDisplayed,
                numPosts,
                version,
                widgetWidth,
                xfbml,
            } = {},
        } = {},
    } = config;

    return (
        <FbComments
            appId={appId}
            buttonText={buttonText}
            cookie={cookie}
            commentsAlwaysOpen={commentsAlwaysOpen}
            commentsClosedHeading={commentsClosedHeading}
            commentsClosedText={commentsClosedText}
            commentsOpenHour={commentsOpenHour}
            commentsCloseHour={commentsCloseHour}
            lang={lang}
            minutesLeftWhenWarningDisplayed={minutesLeftWhenWarningDisplayed}
            numPosts={numPosts}
            url={url}
            version={version}
            widgetWidth={widgetWidth}
            xfbml={xfbml}
            {...rest}
        />
    );
};

export default Comments;



/** WEBPACK FOOTER **
 ** ./src/local-components/article/Comments.js
 **/